import type { AssetDetails } from 'modules/queries/asset/useDetails';
import { acronisProductCodes } from 'utility/acronisProductMap';
import type { NewOrderedAddOn } from './useNewOrderedAddOns';

/**
 * Returns the ordered add-ons that belong to one of the given servers and that
 * the server does not list yet. A server lists an Acronis backup in its
 * backups and storage details and every other add-on in its association
 * details. If the server's details don't include that field, the add-on is
 * not returned.
 */
const getAssetsNewOrderedAddOns = (
	newOrderedAddOns: NewOrderedAddOn[],
	assets: Pick<
		AssetDetails,
		'uniq_id' | 'associationDetails' | 'backupsAndStorage' | 'hasAcronis'
	>[],
) =>
	newOrderedAddOns.filter(({ code, related_subaccnt: relatedSubaccnt }) =>
		assets.some(
			({
				uniq_id: uniqId,
				associationDetails,
				backupsAndStorage,
				hasAcronis,
			}) => {
				if (uniqId !== relatedSubaccnt) {
					return false;
				}

				if (acronisProductCodes.includes(code)) {
					return Boolean(backupsAndStorage) && !hasAcronis;
				}

				return (
					Boolean(associationDetails) &&
					!associationDetails?.some(({ type }) => type === code)
				);
			},
		),
	);

export default getAssetsNewOrderedAddOns;
